import React from 'react';
import { Image } from 'antd';
import { logValueText } from './logLabels';

// 解析正文中的图片 ![](url) 和文件 [name](url)，渲染为缩略图/链接
export function parseContent(text) {
  if (!text) return null;
  const parts = [];
  const regex = /(!\[([^\]]*)\]\(([^)]+)\))|(\[([^\]]+)\]\(([^)]+)\))/g;
  let last = 0;
  let m;
  let key = 0;
  while ((m = regex.exec(text)) !== null) {
    if (m.index > last) parts.push(<span key={key++}>{text.slice(last, m.index)}</span>);
    if (m[1]) {
      parts.push(
        <Image
          key={key++}
          src={m[3]}
          alt={m[2] || ''}
          width={120}
          style={{ margin: '4px 4px 4px 0', borderRadius: 4, verticalAlign: 'middle', objectFit: 'cover', height: 90 }}
        />
      );
    } else {
      parts.push(
        <a key={key++} href={m[6]} target="_blank" rel="noreferrer" style={{ color: '#1890ff', margin: '0 2px' }}>
          {m[5]}
        </a>
      );
    }
    last = regex.lastIndex;
  }
  if (last < text.length) parts.push(<span key={key++}>{text.slice(last)}</span>);
  return parts;
}

// 去掉追加合并文本里的 分隔线+时间戳，仅保留纯内容
export function stripAppendDividers(text) {
  if (!text) return text;
  return ('' + text).replace(/\n*\s*—+\s*【[^】]*】\s*\n*/g, '\n').replace(/\n{3,}/g, '\n\n').trim();
}

// 日志显示值：update 类只取本次增量（new_value 去掉 old_value 前缀与分隔线），
// 其余（状态/优先级等短值）走中文映射；空值返回 ''
export function logDeltaText(log) {
  if (!log) return '';
  let nv = log.new_value;
  if (nv === null || nv === undefined || nv === 'None') return '';
  nv = String(nv);
  if (log.action === 'update' && log.old_value && log.old_value !== 'None') {
    const ov = String(log.old_value);
    if (nv.startsWith(ov)) {
      nv = nv.slice(ov.length).replace(/^\s*—+\s*【[^】]+】\s*\n?/, '').trim();
    }
  }
  return logValueText(nv);
}

// 显示层剥掉来源标记前缀（操作人列已能看出"系统/人工"，无需重复显示）
export function cleanLogRemark(text) {
  if (!text) return text;
  return String(text)
    .replace(/^\s*【系统自动匹配邮件[^】]*】/, '')
    .replace(/^\s*【人工匹配邮件[^】]*】/, '');
}

// 取追加分隔线之后的最新一段；纯图片/文件段标记 mediaOnly
export function latestSegment(text) {
  if (!text) return { text: '', mediaOnly: false };
  const segs = ('' + text).split(/\n*\s*—+\s*【[^】]*】\s*\n*/);
  const latest = (segs[segs.length - 1] || '').trim();
  if (!latest) return { text: '', mediaOnly: false };
  const mediaOnly = latest
    .replace(/!\[[^\]]*\]\([^)]+\)/g, '')
    .replace(/\[[^\]]+\]\([^)]+\)/g, '')
    .trim() === '';
  return { text: latest, mediaOnly };
}

// 「核心问题」类字段统一显示：永远只显示最新一段；纯图片段提示查看详情
export function renderLatestSegment(text, empty = '-') {
  const { text: latest, mediaOnly } = latestSegment(text);
  if (!latest) return <span style={{ color: '#bbb' }}>{empty}</span>;
  if (mediaOnly) return <span style={{ color: '#999', fontSize: 12 }}>存在图片，请点击详情查看</span>;
  return parseContent(latest);
}
